import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function() {
  if ($('.ucg-slider-2-block.style-a .slides .inset').length) {
    if ($('.ucg-slider-2-block.style-a .slides .inset').find('.slide-2').length) {
      $('.ucg-slider-2-block.style-a .slides .inset').not('.slick-initialized').slick({
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
        cssEase: 'ease-out',
        infinite: false,
        nextArrow: '<div class="slick-next"><i class="fa fa-arrow-right"></i></div>',
        pauseOnHover: false,
        pauseonFocus: false,
        prevArrow: '<div class="slick-prev"><i class="fa fa-arrow-left"></i></div>',
        slidesToShow: 1.25,
        slidesToScroll: 1,
        speed: 1000,
      });
    }
  };
  if ($('.ucg-slider-2-block.style-b .slides .inset').length) {
    if ($('.ucg-slider-2-block.style-b .slides .inset').find('.slide-2').length) {
      $('.ucg-slider-2-block.style-b .slides .inset').not('.slick-initialized').slick({
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
        cssEase: 'ease-out',
        infinite: false,
        initialSlide: 1,
        nextArrow: '<div class="slick-next"><i class="fa fa-arrow-right"></i></div>',
        pauseOnHover: false,
        pauseonFocus: false,
        prevArrow: '<div class="slick-prev"><i class="fa fa-arrow-left"></i></div>',
        rtl: true,
        slidesToShow: 1.25,
        slidesToScroll: 1,
        speed: 1000,
      });
    }
  };
})